<template>
  <div>
    <VDataTable
      :headers="headers"
      :items="items"
      item-key="id"
      hide-default-footer
      disable-pagination
      :no-data-text="noVacanciesText"
      :hide-default-header="vacancies.length === 0 || $vuetify.breakpoint.smAndDown"
      :mobile-breakpoint="0"
      class="vacancy-table"
    >
      <template v-slot:item="{ item }">
        <VacancyTableRow
          :headers="headers"
          :key="item.id"
          :company="company"
          :vacancy="item"
          :limited-vacancies="limitedVacancies"
          @openDialogMaximumVacancies="openDialogMaximumVacancies"
          @openDialogExpiredTariff="openDialogExpiredTariff"
        />
      </template>
      <template v-slot:no-data>
        <div class="empty-row">
          {{ noVacanciesText }}
        </div>
      </template>
    </VDataTable>

    <VDialog
      v-model="dialogMaximumVacancies"
      persistent
      max-width="500"
    >
      <DialogLimitedVacancies
        :plan-title="planTitle"
        :title="$t('maxVacanciesTitleCopy')"
        :limited-vacancies="limitedVacancies"
        @close="cancelDialogMaximumVacancies"
      />
    </VDialog>
    <VDialog
      v-model="dialogExpiredTariff"
      persistent
      max-width="600"
    >
      <DialogExpiredTariff @close="cancelDialogExpiredTariff" />
    </VDialog>
  </div>
</template>

<script>
import { prepareVacanciesForTable } from '@/helpers/vacancies';
import DialogLimitedVacanciesMixin from '@/mixins/DialogLimitedVacanciesMixin';
import DialogExpiredTariff from '@/components/DialogExpiredTariff.vue';
import VacancyTableRow from './VacancyTableRow.vue';

export default {
  name: 'VacancyTable',
  components: { VacancyTableRow, DialogExpiredTariff },
  mixins: [DialogLimitedVacanciesMixin],
  props: {
    company: {
      type: Object,
      required: true,
    },
    vacancies: {
      type: Array,
      required: true,
    },
    noDataText: {
      type: String,
      default: null,
    },
    selectData: {
      type: Array,
      required: true,
    },
    selectedUsers: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      noVacanciesText: this.noDataText === null ? this.$t('noData') : this.noDataText,
      dialogExpiredTariff: false,
      headers: [
        {
          text: this.$t('vacancy'),
          value: 'title',
          align: 'left',
          sortable: false,
        },
        { text: this.$t('creator'), value: 'creatorName', sortable: false },
        { text: this.$t('city'), value: 'city' },
        { text: this.$t('candidates'), value: 'candidatesCount' },
        { text: this.$t('interview'), value: 'interviewCount' },
        {
          text: this.$t('testing'), value: 'hasTest', sortable: false,
        },
        {
          text: this.$t('expires'), value: 'publishedTill', sortable: true,
        },
        {
          text: '',
          value: 'action',
          sortable: false,
        },
      ],
      timer: null,
    };
  },
  computed: {
    items() {
      const items = prepareVacanciesForTable(this.vacancies);

      if (items.length > 0) {
        return items;
      }

      if (items.length === 0 && this.selectedUsers.length > 0) {
        this.$emit('clearSelectedUsers');
      }

      return items;
    },
  },
  watch: {
    async selectedUsers() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(async () => {
        this.$emit('fetch', this.selectedUsers);
      }, 1500);
    },
  },
  methods: {
    openDialogExpiredTariff() {
      this.dialogExpiredTariff = true;
    },
    cancelDialogExpiredTariff() {
      this.dialogExpiredTariff = false;
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  maxVacanciesTitleCopy: "You cannot copy the job"
  vacancy: Job
  city: City
  candidates: Candidates
  interview: Interviews
  expires: Expires
  noData: No data
  testing: Testing
  creator: Creator
  newVacancy: New job
</i18n>

<i18n locale="ru" lang="yaml">
  maxVacanciesTitleCopy: 'Вы не можете скопировать вакансию'
  vacancy: Вакансия
  city: Город
  candidates: Кандидаты
  interview: Интервью
  expires: Истекает
  noData: Нет данных
  testing: Тестирование
  creator: Создатель
  newVacancy: Новая вакансия
</i18n>
